import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import Spinner from 'Components/Spinner';
import Box from 'Components/Box';
import { getUrlParams } from 'common/utils/routing.util';
import i18n, {
  AVAILABLE_REG_SERVER_LANGS,
  REG_SERVER_FALLBACK_LANG,
} from 'i18n';
import history from 'customHistory';
import { IS_DISONA } from 'common/utils/style.util';
import { S } from './styles';
import { analyticsService } from '../../common/services/analytics.service';

@inject('AuthStore', 'AppStore')
@observer
class SignInComp extends React.Component {
  _interval;

  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'signIn',
    };
    this._interval = undefined;
  }

  componentDidMount() {
    const { AuthStore, AppStore, location } = this.props;
    if (AuthStore.isAuthorised) history.push(AppStore.initialUrl);
    const params = getUrlParams(location);
    if (params.isLogin === 'true') {
      this.setState({
        activeTab: 'signIn',
      });
    }
    if (params.isLogin === 'false') {
      this.setState({
        activeTab: 'signUp',
      });
      analyticsService.trackDLineRegistrationPageVisit();
    }
  }

  render() {
    const width = '100%';
    const height = 600;
    const { AuthStore } = this.props;
    const { activeTab } = this.state;
    const regServiceLocale = (
      AVAILABLE_REG_SERVER_LANGS.includes(i18n.language)
        ? i18n.language
        : REG_SERVER_FALLBACK_LANG
    ).toUpperCase();
    return (
      <S.Container
        style={{
          height: '100vh',
        }}
      >
        <Box>
          {!IS_DISONA && <S.Icon />}
          {AuthStore.loginUrl && (
            <div>
              {AuthStore.loginUrl === '.' && <Spinner />}
              {AuthStore.loginUrl !== '.' && (
                <iframe
                  src={
                    activeTab === 'signUp'
                      ? `${AuthStore.registrationUrl}/${regServiceLocale}`
                      : `${AuthStore.loginUrl}/${regServiceLocale}`
                  }
                  height={height}
                  width={width}
                  title="sign in"
                  frameBorder="0"
                />
              )}
            </div>
          )}
        </Box>
      </S.Container>
    );
  }
}

export default withRouter(withTranslation()(SignInComp));
